/* eslint-disable max-len */
module.exports = {
  // =================== KnowledgeBase ===================
  knowledgebase: {
    pagetitle: "Knowledge Base",
    vmc: {
      title: "Visual and measuring control of welds",
      backgroundimg: "/img/knowledgebase/vmc-background-01.jpg",
      meta: "Publication date: 25.08.2021",
      content: `
        <p class="uk-text-lead rz-txt-light">The first stage of any non-destructive testing is visual and measuring control (abbreviated as VT or VMC)</p>
        <p>Regardless of the technical devices group (the products purpose), the VT is always used and performed in a volume of 100% both for the base metal and for all welds of the structure</p>
        <p>Radiographic or ultrasound control can be executed only after the VT finished. <span class='rz-txt-light'>VT is the first protection round against obvious the defective weld.</span></p>
        <p>
          <span class="uk-text-bold">The visual test process consists of two stages:</span>
          <ul class="uk-list uk-list-bullet">
            <li><span class="uk-text-bold">Visual inspection</span> with a unarmed look or using magnifying devices;</li>
            <li><span class="uk-text-bold">Measurement</span> of specific geometric parameters using special tools.</li>
          </ul>
          These operations are performed in parallel or alternately.<br>
          Visual and measuring control of the welded joint can not be reduced to a simple inspection.<br>
          This is a fairly strict geometry checking, surface treatment quality and other parameters according to the criteria prescribed in the instructions.
        </p>
        <p>Visual inspection is able to detect only surface defects. This is its main drawback. But the main VT advantages are the ease of implementation, the ability to perform in the field, high speed, inexpensive equipment.</p>
        <div class="uk-flex uk-flex-center"><div class="uk-inline">
          <img class="uk-border-rounded rz-box-shadow-small" data-src="/img/knowledgebase/vmc-01.jpg" width="800" height="450" alt="" uk-img="">
          <div class="uk-overlay uk-light uk-position-bottom"><p class="txt-white txt-stroke-blue-shadow">Measurement of the welding seam altitude</p></div>
        </div></div>
      
      
      `
    }

  }
};
/* eslint-enable max-len */
